import { observer } from "mobx-react";
import { Tooltip } from "../../../../../../../../../components/tooltip/tooltip";
import FontBody2 from "../../../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../../../../../components/fonts/font-props";
import Icon from "../../../../../../../../../components/icons/icon/icon";
import IconInfo from "../../../../../../../../../components/icons/icon-info/icon-info";
import { IOption, SelectDropdown } from "../../../../../../../../../components/inputs/select-dropdown/select-dropdown";
import { ICompareValueTypeComponentProps } from "../condition-field";
import PurchasedCompareValueStore from "../../../../../../../stores/compare-value/purchased-compare-value-store";

const PurchasedCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({store, condition, operatorSelector}) => {
    const compareValueStore: PurchasedCompareValueStore = store as PurchasedCompareValueStore;

    const options = compareValueStore.options as IOption[]
    const selectedOption = options.find(o => o.value === compareValueStore.value);

    return (
        <>
            {operatorSelector}
            
            <SelectDropdown disabled={!condition.isEditMode} value={selectedOption} options={options} onChange={e => compareValueStore.setValue(e?.value as string) } isSearchable={false} />

            {condition.tooltip && (
                <Tooltip content={<div style={{ maxWidth: '200px' }}>
                    <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                        {condition.tooltip}
                    </FontBody2>
                </div>}>
                    <Icon Component={IconInfo} />
                </Tooltip>
            )}
        </>
    );
});

export default PurchasedCompareValueField;